import { z } from 'zod';
/** One portrait with a ready-to-use authorization link (logs the user in + opens the portrait). */
export const PortraitItemDTO = z.object({
    key: z.string(),
    name: z.string(),
    url: z.string(),
});
/**
 * Response for GET /api/conversations/:id/portraits.
 * `configured` is false when the app-service portraits API is not wired
 * (env unset) — the UI then hides the section. `portraits` is empty when the
 * user has no ready portraits (or the contact has no resolved wit_user_id).
 */
export const PortraitsResponse = z.object({
    configured: z.boolean(),
    portraits: z.array(PortraitItemDTO),
});
//# sourceMappingURL=portraits.js.map